import { Injectable, effect, inject } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { TenantContextService } from '@core/tenant/tenant-context.service';

@Injectable({ providedIn: 'root' })
export class SentryTenantContextService {
  private readonly tenantContext = inject(TenantContextService);

  private readonly sync = effect(() => {
    const companyId = this.tenantContext.activeCompanyId();
    Sentry.setTag('company_id', companyId ?? null);
  });
}
